import { ThemeProvider } from "@/components/theme-provider";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { LanguageProvider } from "@/contexts/language-context";
import { AuthProvider } from "@/lib/auth";
import CancelPage from "@/pages/cancel";
import LandingPage from "@/pages/landing";
import LegalPage from "@/pages/legal";
import NotFound from "@/pages/not-found";
import PlansPage from "@/pages/plans";
import SignupPage from "@/pages/signup";
import SuccessPage from "@/pages/success";
import { getGoogleClientId } from "@/services/googleOAuthService";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClientProvider } from "@tanstack/react-query";
import { Route, Switch } from "wouter";
import { queryClient } from "./lib/queryClient";

function Router() {
  return (
    <Switch>
      <Route path='/' component={LandingPage} />
      <Route path='/signup' component={SignupPage} />
      <Route path='/plans' component={PlansPage} />
      <Route path='/success' component={SuccessPage} />
      <Route path='/cancel' component={CancelPage} />
      <Route path='/terms'><LegalPage type='terms' /></Route>
      <Route path='/privacy'><LegalPage type='privacy' /></Route>
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const googleClientId = getGoogleClientId();

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <QueryClientProvider client={queryClient}>
              <TooltipProvider>
                <Toaster />
                <Router />
              </TooltipProvider>
            </QueryClientProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
